const ITEMS = ["Discipline", "Vision", "Loyalty", "Faith", "Move Different", "Leave a Legacy", "Jae Noir", "Est. 2026"];

export default function Marquee({ className = "" }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className={`overflow-hidden border-y border-white/10 py-4 select-none ${className}`} data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-mono2 text-[11px] tracking-[0.4em] uppercase text-cream/35 px-8">{item}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-gold/40 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
